import { routes } from '@/constants/routes';
import { generatePath, useNavigate } from 'react-router';
import React from 'react';
import Button from '@/components/input/Button';
import { ContentType } from '@/services/contents/types';

interface Props {
  contentId: string | string[];
  routeId?: string;
  completed?: boolean;
  contentType: ContentType;
}

const ActionButton: React.FC<Props> = ({ routeId, contentId, completed, contentType }) => {
  const navigate = useNavigate();

  const handleNavigateToCompletePage = () => {
    navigate(generatePath(routes.routes.content.complete, { routeId, contentId }));
  };

  if ((['QUIZ'] as ContentType[]).includes(contentType) || completed) {
    return null;
  }

  return (
    <Button variant="main" onClick={handleNavigateToCompletePage}>
      Completar Contenido
    </Button>
  );
};

export default ActionButton;
